import { APPS } from "./constants";

export const getCableEndpoint = () => {
  const hostname = window && window.location && window.location.hostname;

  if (
    hostname !== "localhost" &&
    !hostname.includes("staging") &&
    hostname.includes("boom")
  ) {
    return "wss://cable.boomhub.app/cable";
  }
  if (hostname !== "localhost" && !hostname.includes("staging")) {
    return "wss://cable.goapps.app/cable";
  }
  if (hostname === "localhost") {
    return "wss://goportal-cable.herokuapp.com/cable";
  }
  return "wss://goapps-staging-cable.herokuapp.com/cable";
};

export const getBoomMathCableEndpoint = () => {
  const hostname = window && window.location && window.location.hostname;
  if (hostname !== "localhost" && !hostname.includes("staging")) {
    return "wss://cable-us-portal.boomhub.app/cable";
  }
  if (hostname === "localhost") {
    return "wss://boomhub-dev-cable.herokuapp.com/cable";
  }
  return "wss://boomhub-staging-cable.herokuapp.com/cable";
};

export const getEndPoint = (app) => {
  const hostname = window && window.location && window.location.hostname;

  let endpoint;

  if (app === APPS.go_read_pupil || app === APPS.go_read_teacher) {
    if (
      hostname !== "localhost" &&
      !hostname.includes("staging") &&
      hostname.includes("boom")
    ) {
      return "https://api-read.boomhub.app";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      return "https://api.go-read.app";
    }
    if (hostname === "localhost") {
      return "https://goread-api.herokuapp.com";
    }
    if (hostname.includes("boom")) {
      return "https://staging.api-read.boomhub.app";
    }
    return "https://staging-api.go-read.app";
    /*endpoint = "https://staging-api.go-read.app";
    if (hostname.includes("boom") ) {
      endpoint = "https://staging.api-read.boomhub.app";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      endpoint = "https://api.go-read.app";
    }
    if (
      hostname !== "localhost" &&
      !hostname.includes("staging") &&
      hostname.includes("boom")
    ) {
      endpoint = "https://api-read.boomhub.app";
    }
    if (hostname === "localhost") {
      endpoint = "https://goread-api.herokuapp.com";
    }*/
  } else if (
    app === APPS.go_admin ||
    app === APPS.go_portal_pupil ||
    app === APPS.go_portal_teacher ||
    app === APPS.go_parents_desktop ||
    app === APPS.go_parents_mobile
  ) {
    if (
      hostname !== "localhost" &&
      !hostname.includes("staging") &&
      hostname.includes("boom")
    ) {
      return "https://api-portal.boomhub.app";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      return "https://api.goapps.app";
    }
    if (hostname === "localhost") {
      return "https://goportal-api.herokuapp.com";
    }
    if (hostname.includes("boom")) {
      return "https://staging.api-portal.boomhub.app";
    }
    return "https://staging-api.goapps.app";
    /*endpoint = "https://staging-api.goapps.app";
    if (hostname.includes("boom")) {
      endpoint = "https://staging.api-portal.boomhub.app";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      endpoint = "https://api.goapps.app";
    }
    if (
      hostname !== "localhost" &&
      !hostname.includes("staging") &&
      hostname.includes("boom")
    ) {
      endpoint = "https://staging.api-portal.boomhub.app";
    }
    if (hostname === "localhost") {
      endpoint = "https://goportal-api.herokuapp.com";
    }*/
  } else if (app === APPS.boom_math_teacher || app === APPS.boom_math_pupil) {
    if (hostname === "localhost") {
      return "https://boom-math-dev.herokuapp.com";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      return "https://api-us-math.boomhub.app";
    }
    return "https://boom-math-staging-api.herokuapp.com";
  } else if (
    app === APPS.boom_math_portal_teacher ||
    app === APPS.boom_math_portal_pupil
  ) {
    if (hostname === "localhost") {
      return "https://boom-portal-dev.herokuapp.com";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      return "https://api-us-portal.boomhub.app";
    }
    return "https://boomhub-portal-staging-api.herokuapp.com";
  } else {
    if (
      hostname !== "localhost" &&
      !hostname.includes("staging") &&
      hostname.includes("boom")
    ) {
      return "https://api-write.boomhub.app";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      return "https://api.go-write.app";
    }
    if (hostname === "localhost") {
      return "https://gowrite-api.herokuapp.com";
    }
    if (hostname.includes("boom")) {
      return "https://staging.api-write.boomhub.app";
    }
    return "https://staging-api.go-write.app";
    /*endpoint = "https://staging-api.go-write.app";
    if (hostname.includes("boom")) {
      endpoint = "staging.api-write.boomhub.app";
    }
    if (hostname !== "localhost" && !hostname.includes("staging")) {
      endpoint = "https://api.go-write.app";
    }
    if (
      hostname !== "localhost" &&
      !hostname.includes("staging") &&
      hostname.includes("boom")
    ) {
      endpoint = "https://api-write.boomhub.app";
    }
    if (hostname === "localhost") {
      endpoint = "https://gowrite-api.herokuapp.com";
    }*/
  }

  /*return endpoint;*/
};
